import React from "react";

const APITestForm = ({ isTest, delay, handleDelayChange, handleIsTestChange, src, onLoad, request }) => {
  return (
    <div className=" " style={{overflowY: 'scroll', height: '600px'}}>
      <label>API Test Page</label>
      <div>
      <label htmlFor="delay_time">delay_time : </label>
      <input 
        id="delay_time"
        value={delay}
        onChange={handleDelayChange}
        disabled={isTest}
      />
      ms
      </div>
      <br />
      <div>
      <button onClick={handleIsTestChange}>{isTest ? "Stop" : "Start"}</button>
      </div>
      {
        request.map((value, index) => {
          return (
            <div key={index}>
              {value}
            </div>
          );
        })
      }
      <iframe
        title="ai-quiz-iframe"
        src={src}
        onLoad={onLoad}
        style={{visibility: "hidden"}}
      ></iframe>
    </div>
  );
};

export default APITestForm;
